import React from 'react'
import PropTypes from 'prop-types'
import { Button, themeColor, themeFontSize, themeFontWeight, themeMediaQuery } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const FilterNumber = styled.span`
    margin-left: 0.5em;
    height: 18px;
    width: 18px;
    display: inline-block;
    font-size: ${themeFontSize('small')};
    font-weight: ${themeFontWeight('book')};
    background: ${themeColor('accent')};
    color: ${themeColor('gray')};
    border-radius: 50%;
`

const ButtonRounded = styled(Button)`
    border: 1px solid ${themeColor('gray')};
    background-color: ${themeColor('white')};
    color: ${themeColor('gray')};
    ${themeMediaQuery('medium')} {
        background-color: ${themeColor('lightGray20')};
    }
`

const ButtonWithFilters = ({ filterNumber, onClick }) => (
    <Button
      onClick={onClick}
      fontWeight='book'
      height='34px'
      padding='0 16px'
      borderRadius='25px'
      fontSize='xxSmall'>
        <FormattedMessage
          defaultMessage='Más filtros'
        />
        <FilterNumber>{ filterNumber }</FilterNumber>
    </Button>
)

ButtonWithFilters.propTypes = {
    onClick: PropTypes.func,
    filterNumber: PropTypes.string,
}

const ButtonEmpty = ({onClick}) => (
    <ButtonRounded
      onClick={onClick}
      fontWeight='book'
      height='34px'
      padding='0 16px'
      borderRadius='25px'
      fontSize='xxSmall'
      >
        <FormattedMessage
          defaultMessage='Más filtros'
        />
    </ButtonRounded>
)

ButtonEmpty.propTypes = {
    onClick: PropTypes.func,
}

export {
    ButtonEmpty,
    ButtonWithFilters,
}

const FilterButton = ({filterNumber, onShowFilters}) => (
    filterNumber
        ? <ButtonWithFilters onClick={onShowFilters} filterNumber={String(filterNumber)} />
        : <ButtonEmpty onClick={onShowFilters} />
)

FilterButton.propTypes = {
    onShowFilters: PropTypes.func,
    filterNumber: PropTypes.number,
}

FilterButton.defaultProps = {
    filterNumber: 0,
}

export default FilterButton
